import { createGettersReducer } from 'react-redux-getters'
import { ME_REPLACE } from 'actions/me'

export default createGettersReducer({
  dropOnAction: ME_REPLACE
})
